/* Iso Water — Quantity "bundle & save" chip selector.
   Non-destructive: enhances the existing quantity <select>, keeps native
   variant/price/cart logic intact. No-op if no quantity/pack option exists. */
(function(){
  function money(n){
    try{ if(window.Shopify && typeof Shopify.formatMoney==='function'){ return Shopify.formatMoney(Math.round(n*100)); } }catch(e){}
    return '$'+Number(n).toFixed(2);
  }
  var NUMWORDS={one:1,single:1,two:2,three:3,four:4,five:5,six:6,seven:7,eight:8,nine:9,ten:10,eleven:11,twelve:12,dozen:12};

  // Units of measure whose numbers must NOT be read as a pack count
  // (e.g. "4 oz", "1.5 lb", "3.5 gpm", "20 micron", "3/4\"").
  var UNIT='(?:oz|ounces?|lbs?|pounds?|kgs?|kg|grams?|gr|mg|g|ml|liters?|litres?|l|gallons?|gal|gpd|gpm|psi|microns?|mesh|mm|cm|ft|inches|inch|in|"|\')';
  function stripMeasures(s){
    return s
      .replace(/\d+(?:\.\d+)?\s*\/\s*\d+(?:\.\d+)?\s*(?:"|inch\w*|in\b)?/g,' ')
      .replace(new RegExp('\\d+(?:\\.\\d+)?\\s*'+UNIT+'\\b','g'),' ');
  }

  // Real pack count from a label, ignoring size/measure numbers like "4 oz".
  function qtyOf(str){
    var s=String(str).toLowerCase();
    if(/\bsingles?\b/.test(s)) return 1;
    var cleaned=stripMeasures(s);
    var COUNT='(?:packe?ts?|packs?|pcs?|pieces?|counts?|ct|bundles?|boxe?s?|dozen|units?|rolls?|filters?|cartridges?)';
    var m=cleaned.match(new RegExp('(\\d[\\d,]*)\\s*-?\\s*'+COUNT+'\\b'))
        || cleaned.match(new RegExp('\\b'+COUNT+'\\s*(?:of\\s*)?(\\d[\\d,]*)'));
    if(m){ return parseInt(m[1].replace(/,/g,''),10); }
    if(/\bdozen\b/.test(cleaned)) return 12;
    var nums=cleaned.match(/\d[\d,]*/g);
    if(nums&&nums.length===1){ return parseInt(nums[0].replace(/,/g,''),10); }
    for(var w in NUMWORDS){ if(new RegExp('\\b'+w+'\\b').test(cleaned)){ return NUMWORDS[w]; } }
    return 1;
  }
  // Only treat an option as a quantity/bundle option when its values carry a
  // genuine quantity word. Excludes add-on "Set of N" options and dimensions
  // like 5/16" x 1" that would otherwise be mistaken for quantities.
  function looksLikeQty(str){ return /\bsingle\b|pack|bundle|\bpcs\b|\bpieces\b|\bqty\b|\bcount\b|\bdozen\b/i.test(String(str)); }
  function isBareNumber(str){ return /^\s*\d[\d,]*\s*$/.test(String(str)); }
  function cleanLabel(str){ return String(str).replace(/\s+/g,' ').trim(); }

  function init(){
    var host=document.querySelector('.iqc[data-iqc]');
    if(!host || host.getAttribute('data-ready')==='1') return;
    var jsonEl=document.querySelector('[id^="ProductJson-"]');
    if(!jsonEl) return;
    var SECTION=jsonEl.id.replace('ProductJson-','');
    var product; try{ product=JSON.parse(jsonEl.textContent); }catch(e){ return; }
    var variants=(product&&product.variants)||[];
    if(!variants.length) return;
    var selects=Array.prototype.slice.call(document.querySelectorAll('.single-option-selector-'+SECTION));
    if(!selects.length) return;

    var byIndex={};
    selects.forEach(function(s){
      var di=s.getAttribute('data-index')||'';
      var idx=parseInt(di.replace('option',''),10);
      if(idx){ byIndex[idx]=s; }
    });

    // Pick the option with the MOST quantity-like values (need >=2), so a stray
    // "/ Single" inside e.g. a Connection value can't hijack detection.
    var qSelect=null,qIndex=null,bestScore=0;
    Object.keys(byIndex).forEach(function(i){
      var s=byIndex[i];
      var vals=Array.prototype.map.call(s.options,function(o){return o.value;});
      var score=vals.filter(looksLikeQty).length;
      if(score>bestScore){ bestScore=score; qSelect=s; qIndex=parseInt(i,10); }
    });
    if(!qSelect || bestScore<2) return;

    host.setAttribute('data-ready','1');

    var wrapper=qSelect.closest('.product-variations')||qSelect.parentNode;
    var nativeBox=qSelect.closest('.select-box')||qSelect;
    if(wrapper){ wrapper.appendChild(host); }
    if(nativeBox){ nativeBox.classList.add('iqc-native-hidden'); }
    try{
      var lbl=wrapper&&wrapper.querySelector('label');
      if(lbl && !lbl.querySelector('.iqc__savehint')){
        var h=document.createElement('span'); h.className='iqc__savehint'; h.textContent='· bundle & save'; lbl.appendChild(h);
      }
    }catch(e){}

    host.hidden=false;
    var grid=host.querySelector('[data-iqc-grid]');

    function currentValues(overrideValue){
      var vals={};
      Object.keys(byIndex).forEach(function(i){ vals[i]=byIndex[i].value; });
      if(overrideValue!=null){ vals[qIndex]=overrideValue; }
      return vals;
    }
    function findVariant(vals){
      return variants.find(function(v){
        return Object.keys(byIndex).every(function(i){ return String(v['option'+i]||'')===String(vals[i]); });
      });
    }
    function infoFor(value){
      var v=findVariant(currentValues(value));
      if(!v) return null;
      var q=qtyOf(value);
      return { price:v.price/100, per:(v.price/100)/q, qty:q, available:v.available };
    }

    var qValues=Array.prototype.map.call(qSelect.options,function(o){return o.value;});

    function render(){
      var info={},baseline=null,minQty=Infinity;
      qValues.forEach(function(val){
        var p=infoFor(val); info[val]=p;
        if(p){ p.count=looksLikeQty(val)||isBareNumber(val); }
        if(p && p.count && p.qty<minQty){ minQty=p.qty; baseline=p.per; }
      });
      var bestVal=null,bestPct=0;
      qValues.forEach(function(val){
        var p=info[val]; if(!p||!p.count||baseline==null) return;
        var pct=Math.round((baseline-p.per)/baseline*100);
        if(pct>bestPct){ bestPct=pct; bestVal=val; }
      });
      grid.innerHTML='';
      qValues.forEach(function(val){
        var p=info[val];
        var isCount=p?p.count:(looksLikeQty(val)||isBareNumber(val));
        var pct=(p&&isCount&&baseline!=null)?Math.round((baseline-p.per)/baseline*100):0;
        var label,each;
        if(isCount){
          var q=p?p.qty:qtyOf(val);
          label=(q<=1)?'Single':('Qty '+q);
          each=p?('<div class="iqc__each">'+money(p.per)+'/ea</div>'):'<div class="iqc__each">&nbsp;</div>';
        }else{
          label=cleanLabel(val);
          each=p?('<div class="iqc__each">'+money(p.price)+'</div>'):'<div class="iqc__each">&nbsp;</div>';
        }
        var tag=pct>0?('<span class="iqc__tag'+(val===bestVal?' is-best':'')+'">'+(val===bestVal?'BEST · ':'')+'SAVE '+pct+'%</span>'):'';
        var btn=document.createElement('button');
        btn.type='button';
        btn.className='iqc__chip'+(qSelect.value===val?' is-active':'');
        if(p && p.available===false){ btn.disabled=true; }
        btn.innerHTML=tag+'<div class="iqc__q">'+label+'</div>'+each;
        btn.addEventListener('click',function(){
          if(btn.disabled) return;
          qSelect.value=val;
          qSelect.dispatchEvent(new Event('change',{bubbles:true}));
          if(window.jQuery){ try{ window.jQuery(qSelect).trigger('change'); }catch(e){} }
          syncActive();
        });
        grid.appendChild(btn);
      });
    }
    function syncActive(){
      Array.prototype.forEach.call(grid.children,function(btn,i){
        btn.classList.toggle('is-active', qSelect.options[i] && qSelect.options[i].value===qSelect.value);
      });
    }
    Object.keys(byIndex).forEach(function(i){
      if(parseInt(i,10)===qIndex) return;
      byIndex[i].addEventListener('change',function(){ render(); });
    });
    qSelect.addEventListener('change',syncActive);
    render();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); }
  else { init(); }
  setTimeout(init,600);
})();
